var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8922 6.46928L15.9997 13.3716L9.10721 6.46928C8.42292 5.78402 7.43352 5.85506 6.64439 6.64468C5.85526 7.43493 5.78432 8.42636 6.46798 9.11163L13.3605 16.0139L6.50189 22.8823C5.81948 23.5656 5.87975 24.6174 6.64439 25.3832C7.40904 26.1489 8.4587 26.208 9.14111 25.5252L15.9997 18.6569L22.8583 25.5252C23.5407 26.2086 24.591 26.1483 25.3556 25.3825C26.1203 24.6168 26.1793 23.5656 25.4975 22.8823L18.6389 16.0139L25.5314 9.11163C26.2157 8.42636 26.1448 7.43556 25.3563 6.64531C24.5678 5.85506 23.5771 5.78402 22.8928 6.46865L22.8922 6.46928Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a8e506e5f52babdc7a4ea9b668f23146.svg";
export { ForwardRef as ReactComponent };